import { VendorDetail } from '../../../components/Vendor';

export function Vendor() {
  return <VendorDetail />;
}
